import { BackButton } from "@components/back-button";
import styles from "./breadcrumbs.module.scss";

type Props = {
  items: string[];
};

export const Breadcrumbs = ({ items }: Props) => {
  return (
    <nav className={styles.breadcrumbs}>
      <BackButton />
      <span className={styles.text}>{`/ ${items.join(" / ")}`}</span>
    </nav>
  );
};
